import { render, staticRenderFns } from "./UserBoxes.vue?vue&type=template&id=2e194a8a&scoped=true"
import script from "./UserBoxes.vue?vue&type=script&lang=js"
export * from "./UserBoxes.vue?vue&type=script&lang=js"
import style0 from "./UserBoxes.vue?vue&type=style&index=0&id=2e194a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e194a8a",
  null
  
)

export default component.exports